import { useState, useContext, useEffect } from "react"
import { CMultiSelect, CToggle, ReportSelectPeriod, TablePage, toast, CSelect, CSkeletonTable, ModalDelete, TablePagination, CheckPermission, ModalFilterUser } from "../../../components/widget"
import { ContextNav, ContextDelay, ContextLoading, ContextDashboard } from "../../../context";
import { DelayApi, DelayExport, DelayChangeStatusApi } from "../../../api";
import { useSearchParams } from "react-router-dom";
import { convertDateToString, converDurationToMin, convertStringDateToDateSupport } from "../../../utils";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"

export const Delay = () => {
    const [searchParams] = useSearchParams();
    const CtxNav = useContext(ContextNav)
    const CtxDelay = useContext(ContextDelay)
    const CtxLoad = useContext(ContextLoading)
    const CtxDash = useContext(ContextDashboard)
    const [visibleUser, setVisibleUser] = useState<boolean>(false)
    const [total, setTotal] = useState<any>(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [lastPage, setLastPage] = useState(0);
    const [tableData, setTableData] = useState<any>([])
    const col: any = [
        {
            title: "کارمند ",
            render: (i: any) => (<span >{i.user && i.user != null && i.user.name}</span>)
        },
        {
            title: "تاریخ ",
            render: (i: any) => (<>{i.created_at && i.created_at != null && new Date(i.created_at).toLocaleDateString('fa-Ir')}</>)
        },
        {
            title: "میزان تاخیر ",
            render: (i: any) => (<>{i.duration && i.duration != null && converDurationToMin(i.duration)}</>)
        },
        {
            title: "علت ",
            render: (i: any) => (<>{i.reason && i.reason != null && i.reason?.description}</>)
        },
        {
            title: "توضیحات ",
            render: (i: any) => (<>{i.description && i.description != null && i.description}</>)
        },
        {
            title: "وضعیت ",
            render: (i: any) => (<>
                {i.status && i.status != null && i.status == 0 && "بررسی نشده"}
                {i.status && i.status != null && i.status == 1 && "موجه"}
                {i.status && i.status != null && i.status == 2 && "غیر موجه"}
            </>)
        },
        {
            title: "اقدامات",
            render: (i: any) => (
                <div className="flex h-[45px] items-center w-full justify-around ">
                    {CheckPermission(9) &&
                        <div onClick={() => changeStatus(i.id, i.status, 1)} className="flex flex-col justify-center items-center cursor-pointer">
                            <svg x="0px" y="0px" viewBox="0 0 58 58" className={`  h-5 ${i.status == 1 ? 'fill-green-500' : 'fill-gray-300 '} `}>
                                <use xlinkHref="/assetes/svg/like.svg#like" />
                            </svg>
                            <span className="text-[11px] mt-1">موجه</span>
                        </div>
                    }
                    {CheckPermission(10) &&
                        <div onClick={() => changeStatus(i.id, i.status, 2)} className="flex flex-col justify-center items-center cursor-pointer">
                            <svg x="0px" y="0px" viewBox="0 0 58 58" className={`  h-5 scale-y-[-1] ${i.status == 2 ? 'fill-red-500' : 'fill-gray-300 '} `}>
                                <use xlinkHref="/assetes/svg/like.svg#like" />
                            </svg>
                            <span className="text-[11px] mt-1">غیرموجه</span>
                        </div>
                    }
                </div>)
        },
    ]

    const exportFile = async (type: string) => {
        const res: any = await DelayExport(CtxDelay.jsonParmsDelay, type)
        var el = document.createElement("a");
        el.setAttribute("href", res);
        el.setAttribute("download", type == 'csv' ? 'export.csv' : 'export');
        el.setAttribute("target", '_blank');
        document.body.appendChild(el);
        el.click();
        el.remove();
    }

    const changePage = (type: string) => {
        let data = { ...CtxDelay.jsonParmsDelay };
        if (type == 'next') {
            data['page'] = currentPage + 1;
        }
        else {
            data['page'] = currentPage - 1;
        }
        CtxDelay.setJsonParmsDelay(data)
        getData(data)
    }

    const changeStatus = async (id: any, currentStatus: any, newStatus: any) => {
        if (currentStatus == newStatus) return
        CtxLoad.setDisplayLoadingBlur(true)
        let res = await DelayChangeStatusApi(id, newStatus)
        if (res.success) {
            getData(CtxDelay.jsonParmsDelay)
            CtxLoad.setDisplayLoadingBlur(false)
            toast("تغییر وضعیت صورت گرفت", { type: "success" })
        }
        else {
            CtxLoad.setDisplayLoadingBlur(false)
            toast(res.message, { type: "error" })
        }
    }

    const handelSelectUsers = (userId: any) => {
        let data = { ...CtxDelay.jsonParmsDelay };
        if (data['user']) {
            if (data['user'].indexOf(userId) == -1) {
                data['user'].push(userId)
            }
            else {
                data['user'].splice(data['user'].indexOf(userId), 1)
            }
        }
        else {
            data['user'] = [userId];
        }
        CtxDelay.setJsonParmsDelay(data)
    }

    const handelFilterUser = () => {
        setVisibleUser(false)
        getData(CtxDelay.jsonParmsDelay)
    }

    const handelSelect = (e: any, name: any) => {
        let data = { ...CtxDelay.jsonParmsDelay };
        let active = { ...CtxDelay.activeFilterDelay };
        if (e.target.value != 'all') {
            data[name] = e.target.value;
            active[name] = e.target.value;
        }
        else {
            delete data[name];
            active[name] = -1;
        }
        CtxDelay.setJsonParmsDelay(data)
        CtxDelay.setActiveFilterDelay(active)
        getData(data)
    }

    const handelSearchQuery = (value: any, name: any) => {
        let data: any = { 'page': 1, 'user': [] };
        let active = { ...CtxDelay.activeFilterDelay };
        data[name] = value;
        active[name] = value;
        CtxDelay.setJsonParmsDelay(data)
        CtxDelay.setActiveFilterDelay(active)
        getData(data)
    }

    const handelSelectCustomTime = (e: any, type: string) => {
        let data = { ...CtxDelay.jsonParmsDelay };
        let active = { ...CtxDelay.activeFilterDelay };
        if (type == 'from') {
            data['from'] = convertStringDateToDateSupport(e?.toDate?.().toString());
            active['startCalender'] = new Date(e?.toDate?.().toString());
        }
        else if (type == 'to') {
            data['to'] = convertStringDateToDateSupport(e?.toDate?.().toString());
            active['endCalender'] = new Date(e?.toDate?.().toString());
        }
        CtxDelay.setJsonParmsDelay(data)
        CtxDelay.setActiveFilterDelay(active)
        getData(data)
    }

    const handelSelectPeriod = (value: any) => {
        let data = { ...CtxDelay.jsonParmsDelay };
        let active = { ...CtxDelay.activeFilterDelay };
        data['from'] = value[0].from;
        data['to'] = value[0].to;
        active['activePeriod'] = value[1]
        active['startCalender'] = new Date(value[0].from);
        active['endCalender'] = new Date(value[0].to);
        CtxDelay.setJsonParmsDelay(data)
        CtxDelay.setActiveFilterDelay(active)
        getData(data)
    }

    const getData = async (parms: any) => {
        try {
            CtxLoad.setDisplayLoadingSkelton(true)
            let res = await DelayApi(parms)
            setTableData(res.data.reasons.data)
            setTotal(res.data.totals)
            CtxLoad.setDisplayLoadingSkelton(false)
            setCurrentPage(res.data.reasons.current_page)
            setLastPage(res.data.reasons.last_page)
        }
        catch (err: any) {
            CtxLoad.setDisplayLoadingSkelton(false)
        }
    }

    useEffect(() => {
        document.title = "تاخیر | دایان"
        CtxNav.setActiveMenuItem({ 'item': 1, 'subItem': 1, })
        if (searchParams.get('status') != null) {
            handelSearchQuery(searchParams.get('status'), 'status')
        }
        else {
            getData(CtxDelay.jsonParmsDelay)
        }
    }, [])

    return (
        <div className=" w-full flex flex-col">
            <h1 className="sm:text-2xl text-lg font-bold mb-[30px]">تاخیرهای پرسنل</h1>

            {CheckPermission(7) &&
                <div className=" w-full flex flex-wrap items-center">
                    <div className=" w-full  flex flex-wrap sm:flex-nowrap items-center pl-0 md:pl-2 justify-between">
                        <div onClick={() => { setVisibleUser(true) }} className="w-[49%] sm:w-[32%] h-[40px] sm:h-[50px] bg-white rounded-md shadow px-[15px] sm:text-[13px] text-[11px] flex items-center  cursor-pointer">
                            <span>{CtxDelay.jsonParmsDelay?.user.length == 0 && 'انتخاب کارمند'}</span>
                            <span>{CtxDelay.jsonParmsDelay?.user.length > 0 && `${CtxDelay.jsonParmsDelay?.user.length} کارمند انتخاب شد`}</span>
                        </div>
                        <div className=" w-[50%] sm:w-[32%] h-[40px] sm:h-[50px] bg-white rounded-md shadow text-sm">
                            <CSelect defaultValue={CtxDelay.activeFilterDelay.qr_code_id != -1 ? CtxDelay.activeFilterDelay.qr_code_id : ""} placeholder={'موقعیت مکانی'} onChange={(e: any) => handelSelect(e, 'qr_code_id')} >
                                <option value={'all'}>همه</option>
                                {CtxDash.location?.map((item: any, index: number) =>
                                    <option value={item.id}>{item.name}</option>
                                )}
                            </CSelect>
                        </div>
                        <div className=" w-full sm:w-[32%] h-[40px] sm:h-[50px] mt-[7px] sm:mt-0 bg-white rounded-md shadow text-sm">
                            <CSelect defaultValue={CtxDelay.activeFilterDelay.status != -1 ? CtxDelay.activeFilterDelay.status : ""} placeholder={'وضعیت'} onChange={(e: any) => handelSelect(e, 'status')} >
                                <option value={'all'}>همه</option>
                                <option value={0}>بررسی نشده</option>
                                <option value={1}>موجه</option>
                                <option value={2}>غیر موجه</option>
                            </CSelect>
                        </div>
                    </div>
                </div>
            }

            {CheckPermission(7) &&
                <div className=" w-full flex md:flex-row flex-col items-center justify-between  mt-[7px] md:mt-[25px]">
                    <div className="w-full md:w-fit flex items-center">
                        <div className="   hidden md:flex items-center pl-2">
                            <div onClick={() => exportFile('csv')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer">
                                <svg x="0px" y="0px" viewBox="0 0 548.29 548.291" className={`  h-7 fill-white `}>
                                    <use xlinkHref="/assetes/svg/csv.svg#csv" />
                                </svg>
                            </div>
                            <div onClick={() => exportFile('excel')} className=" w-[60px] h-[60px] bg-dayan-gray-200 rounded-md flex justify-center items-center cursor-pointer mr-2">
                                <svg x="0px" y="0px" viewBox="0 0 26 26" className={`  h-7 fill-green-800 `}>
                                    <use xlinkHref="/assetes/svg/excel.svg#excel" />
                                </svg>
                            </div>
                        </div>
                        <div className=" w-full md:w-[240px] flex flex-col">
                            <ReportSelectPeriod onChange={(value: any) => handelSelectPeriod(value)} activeTab={CtxDelay.activeFilterDelay.activePeriod} />
                            <div className=" w-full flex   mt-2">
                                <div className="jalali-datePicker w-full h-[30px] ml-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                    <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ شروع</div>
                                    <DatePicker calendar={persian} locale={persian_fa} value={CtxDelay.activeFilterDelay?.startCalender} onChange={(e: any) => { handelSelectCustomTime(e, 'from') }} />
                                </div>
                                <div className="jalali-datePicker w-full h-[30px] mr-1 bg-white rounded-lg shadow flex justify-center items-center text-[11px] relative group">
                                    <div className="bg-dayan-gray-200 w-fit h-[20px] px-1 absolute text-white flex justify-center items-center bottom-[-60px] text-[10px] rounded opacity-0 invisible group-hover:bottom-[-23px] group-hover:opacity-100 group-hover:visible transition-all ">تاریخ پایان</div>
                                    <DatePicker calendar={persian} locale={persian_fa} value={CtxDelay.activeFilterDelay?.endCalender} onChange={(e: any) => { handelSelectCustomTime(e, 'to') }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className=" w-full md:w-fit flex items-center md:mt-0 mt-[7px]">
                        <button onClick={() => exportFile('csv')} className="w-full md:w-[120px] h-[30px] md:h-[40px] md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">CSV</button>
                        <button onClick={() => exportFile('excel')} className="w-full md:w-[120px] h-[30px] md:h-[40px] mx-1 md:hidden flex bg-dayan-gray-200 rounded-md text-sm text-white justify-center items-center text-center text-[11px]">اکسل</button>
                    </div>
                </div>
            }

            {CheckPermission(8) &&
                <div className=" w-full mt-[20px]">
                    {CtxLoad.displayLoadingSkelton == false ?
                        <TablePage columns={col} data={tableData} >
                            <TablePagination currentPage={currentPage} lastPage={lastPage} onChange={changePage} />
                        </TablePage>
                        :
                        <CSkeletonTable />
                    }
                </div>
            }


            {CheckPermission(8) &&
                <>
                    {total != null && tableData?.length > 0 &&
                        <div className=" w-full my-[40px] px-3 flex flex-col rounded-lg overflow-hidden table-report-shadow bg-[#f8f8f8]">
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                                مجموع کل تاخیرها : {converDurationToMin(total.all)}
                            </div>
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                                مجموع تاخیرهای بررسی‌نشده : {converDurationToMin(total.pending)}
                            </div>
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end border-b text-[12px]">
                                مجموع تاخیرهای موجه‌شده : {converDurationToMin(total.approved)}
                            </div>
                            <div className="w-full min-h-[40px] py-2 flex items-center justify-start sm:justify-end text-[12px]">
                                مجموع تاخیرهای غیرموجه :  {converDurationToMin(total.rejected)}
                            </div>
                        </div>
                    }
                </>
            }

            <ModalFilterUser visible={visibleUser} setVisible={setVisibleUser} onOk={handelFilterUser} listUser={CtxDash.employees} listSelected={CtxDelay.jsonParmsDelay?.user} selectUser={handelSelectUsers} />

        </div>
    )
}

